// Dados cadastrais da empresa, usados no cabeçalho de relatórios e propostas.
// Os mesmos do rodapé do site (curraltech.com) e do cadastro na Apple.
export const EMPRESA = {
  razaoSocial: 'CURRALTECH LTDA',
  nomeFantasia: 'Curral Tech',
  cnpj: '49.179.954/0001-00',
  endereco: 'Av. Júlia Maksoud, 1060, Monte Castelo',
  cidade: 'Campo Grande/MS',
  cep: '79011-100',
  email: 'contato@curraltech.com',
  site: 'curraltech.com',
} as const;
